import * as Sentry from '@sentry/vue';

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();
  const dsn = String(config.public.sentryDsn || '');
  const environment = String(config.public.sentryEnvironment || 'production');
  const release = String(config.public.sentryRelease || 'landing-page@dev');

  if (!dsn) {
    return;
  }

  Sentry.init({
    app: nuxtApp.vueApp,
    dsn,
    environment,
    release,
    tracesSampleRate: 0.1,
    enabled: !config.public.isDev,
  });

  nuxtApp.hook('app:error', (error) => {
    Sentry.captureException(error, {
      tags: {
        source: 'nuxt-client-app',
      },
    });
  });

  const sentryWindow = window as typeof window & { Sentry?: typeof Sentry };
  sentryWindow.Sentry = Sentry;

  return {
    provide: {
      sentry: Sentry,
    },
  };
});
